export default {
  "en": {
    "announcement": {
      "actions": {
        "delete_announcement": "Delete news post",
        "edit": "Edit",
        "new": "New post",
        "save": "Save",
        "submit": "Post"
      },
      "attributes": {
        "description": "Description"
      },
      "labels": {
        "change_announcement_levels": "Change announcement levels",
        "customers": "customers",
        "for": "for",
        "image_tab": "Image",
        "now": "Now",
        "partiallyShared": "{project_name} (partially shared)",
        "start": "Start",
        "unitsCount": "1 Unit | {count} Units",
        "video_tab": "Video",
        "youtube_video": "YouTube video URL"
      },
      "name": "Announcement",
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Soon you'll find regular updates about the construction site on your dashboard.",
            "title": "Get your news here!"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Welcome your customers or share an update about the project.",
            "title": "Create your first News Post"
          },
          "none": {
            "project_required": "Select a project",
            "subtitle": "Welcome your customers or share an update about any project."
          },
          "paste_video_url": "Paste your YouTube link here"
        }
      },
      "toasts": {
        "create": "News post published",
        "delete": "News post deleted",
        "invalid_video": "This is not a valid YouTube video",
        "update": "News post has been updated"
      },
      "validation": {
        "pleaseAddContent": "Add an image, video or description"
      }
    }
  }
}